<template>
    <div>
      <editor-menu-bar :editor="editor" v-slot:default="{ commands, isActive, getMarkAttrs }">
        <div class="menubar">
          <button class="menubar__button" :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
            <font-awesome-icon icon="bold"/>
          </button>
          <button class="menubar__button" :class="{ 'is-active': isActive.italic() }" @click="commands.italic">
            <font-awesome-icon icon="italic"/>
          </button>
          <button class="menubar__button" :class="{ 'is-active': isActive.strike() }" @click="commands.strike">
            <font-awesome-icon icon="strikethrough"/>
          </button>
          <button class="menubar__button" :class="{ 'is-active': isActive.underline() }" @click="commands.underline">
            <font-awesome-icon icon="underline"/>
          </button>
          <button class="menubar__button" :class="{ 'is-active': isActive.link() }" @click="toggleLinkMenu(getMarkAttrs('link'))">
            <font-awesome-icon icon="link"/>
          </button>
          <button class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 1 }) }" @click="commands.heading({ level: 1 })">
            H1
          </button>
          <button class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 2 }) }" @click="commands.heading({ level: 2 })">
            H2
          </button>
          <button class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click="commands.heading({ level: 3 })">
            H3
          </button>
          <button class="menubar__button" @click="toggleImageMenu">
            <font-awesome-icon icon="image"/>
          </button>
          <button class="menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click="commands.bullet_list">
            <font-awesome-icon icon="list-ul"/>
          </button>
          <button class="menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click="commands.ordered_list">
            <font-awesome-icon icon="list-ol"/>
          </button>
          <button class="menubar__button" @click="commands.undo">
            <font-awesome-icon icon="undo"/>
          </button>
          <button class="menubar__button" @click="commands.redo">
            <font-awesome-icon icon="redo"/>
          </button>
          <b-form v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
            <b-row class="my-3 p-0">
              <b-col cols="9">
                <b-input type="text" v-model="linkUrl" placeholder="https://" ref="linkInput"
                @keydown.esc="hideLinkMenu"/>
              </b-col>
              <b-col cols="3">
                <b-button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button">
                  <font-awesome-icon icon="trash-alt"/>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
          <b-form v-if="imageMenuIsActive" @submit.prevent="setImage(commands.image, imageUrl)">
            <b-row class="my-3 p-0">
              <b-col cols="9">
                <b-input type="text" v-model="imageUrl" placeholder="https://" ref="imageInput"
                @keydown.esc="hideImageMenu"/>
              </b-col>
              <b-col cols="3">
                <b-button class="menububble__button" @click="setImage(commands.link, null)" type="button">
                  <font-awesome-icon icon="trash-alt"/>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </editor-menu-bar>
      <editor-content class="editor form-control h-auto" :editor="editor" />
    </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Heading,
  Image,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Italic,
  Strike,
  Underline,
  Link,
  History,
} from 'tiptap-extensions';

export default {
  components: {
    EditorContent,
    EditorMenuBar,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    editor: null,
    linkUrl: null,
    linkMenuIsActive: false,
    imageMenuIsActive: false,
    imageUrl: null,
  }),
  mounted() {
    this.editor = new Editor({
      content: this.value,
      extensions: [
        new BulletList(),
        new Heading({ levels: [ 1, 2, 3 ] }),
        new Image(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Bold(),
        new Italic(),
        new Strike(),
        new Underline(),
        new Link(),
        new History(),
      ],
      onUpdate: ({ getHTML }) => {
        let htmlContent = this.editor.getHTML();
        console.log(htmlContent);
        // align image center hack @TODO: remove when alignment is added
        htmlContent = htmlContent.replace(/<p><img/g, '<p style="text-align: center"><img');
        this.$emit('input', htmlContent);
      },
    });
  },
  methods: {
    getHtmlContent() {
      let htmlContent = this.editor.getHTML();
      console.log(htmlContent);
      // align image center hack @TODO: remove when alignment is added
      htmlContent = htmlContent.replace(/<p><img/g, '<p style="text-align: center"><img');
      this.$emit('input', htmlContent);
    },
    setContent(content) {
      this.editor.setContent(content);
    },
    toggleLinkMenu(attrs) {
      if (this.linkMenuIsActive) {
        this.hideLinkMenu();
      } else {
        this.linkUrl = attrs.href;
        this.linkMenuIsActive = true;
        this.$nextTick(() => {
          this.$refs.linkInput.focus();
        });
      }
    },
    hideLinkMenu() {
      this.linkUrl = null;
      this.linkMenuIsActive = false;
    },
    setLinkUrl(command, url) {
      command({ href: url });
      this.hideLinkMenu();
    },
    toggleImageMenu(attrs) {
      if (this.imageMenuIsActive) {
        this.hideImageMenu();
      } else {
        this.imageMenuIsActive = true;
        this.$nextTick(() => {
          this.$refs.imageInput.focus();
        });
      }
    },
    hideImageMenu() {
      this.imageUrl = null;
      this.imageMenuIsActive = false;
    },
    setImage(command, src) {
      command({ src });
      this.hideImageMenu();
    },
  },
  beforeDestroy() {
    this.editor.destroy();
    this.editor = null;
  },
};
</script>

<style lang="scss">
  .form-group .editor.form-control {
    height: auto !important;
  }
  .ProseMirror {
    * {
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
      -webkit-touch-callout: none;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-rendering: optimizeLegibility;
      color: #333 !important;

      &:focus {
        outline: none !important;
      }
    }
  }

  .ProseMirror-focused {
    outline: none !important;
  }

  .menubar {
    margin-bottom: 1rem;
    transition: visibility 0.2s 0.4s, opacity 0.2s 0.4s;

    &.is-hidden {
      visibility: hidden;
      opacity: 0;
    }

    &.is-focused {
      visibility: visible;
      opacity: 1;
      transition: visibility 0.2s, opacity 0.2s;
    }

    &__button {
      font-weight: bold;
      display: inline-flex;
      background: transparent;
      border: 0;
      color: #333;
      padding: 0.2rem 0.5rem;
      margin-right: 0.2rem;
      border-radius: 3px;
      cursor: pointer;

      &:hover {
        background-color: rgba(#333, 0.05);
      }

      &.is-active {
        background-color: rgba(#333, 0.1);
      }
    }

    span#{&}__button {
      font-size: 13.3333px;
    }
  }

  .ProseMirror {
    a {
      color: inherit;
      text-decoration: underline;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/misc/TiptapEditor.vue